<div class="layout {{class}}">
  <ng-content></ng-content>
</div>
